import { gql } from '@apollo/client';

export const tenantFragment = gql`
  fragment tenantsFields on tenants {
    name
    id
    address
    timezone
    tenantId: tenant_id
  }
`;
